import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forYou = ["Sientes que llevas demasiado tiempo 'sobreviviendo' en lugar de vivir", 'Has intentado otros métodos y algo sigue sin cambiar', 'Tienes fe — o quieres tenerla — pero sientes que Dios está lejos', 'Sabes que algo dentro de ti se rompió... y también que algo dentro de ti aún no se rindió', 'Sientes que el tiempo corre y quieres dejar de postergarlo', 'Quieres dejar una historia diferente — para ti y para los tuyos'];
const notForYou = ['Buscas magia instantánea o motivación barata', 'No estás dispuesto a entrar en el barro de tu propia historia', 'Esperas que alguien más haga el trabajo por ti'];
export function ForYouNotForYou() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[var(--midnight)] py-24 md:py-32" data-id="element-169">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-6xl mx-auto px-6" data-id="element-170">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-171">
          {/* For You */}
          <div className="space-y-8" data-id="element-172">
            <h2 className="font-display text-3xl md:text-4xl text-[var(--warm-gold)]" data-id="element-173">
              Esto Es Para Ti Si...
            </h2>

            <div className="space-y-4" data-id="element-174">
              {forYou.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex gap-4 items-start" data-id="element-175">
                  <div className="flex-shrink-0 w-6 h-6 bg-[var(--warm-gold)] rounded-full flex items-center justify-center mt-1" data-id="element-176">
                    <Check className="w-4 h-4 text-[var(--midnight)]" data-id="element-177" />
                  </div>
                  <p className="text-[var(--cream)] leading-relaxed" data-id="element-178">{item}</p>
                </motion.div>)}
            </div>
          </div>

          {/* Not For You */}
          <div className="space-y-8" data-id="element-179">
            <h2 className="font-display text-3xl md:text-4xl text-[var(--sunset-coral)]" data-id="element-180">
              Esto NO Es Para Ti Si...
            </h2>

            <div className="space-y-4" data-id="element-181">
              {notForYou.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="flex gap-4 items-start" data-id="element-182">
                  <div className="flex-shrink-0 w-6 h-6 bg-[var(--sunset-coral)]/30 rounded-full flex items-center justify-center mt-1" data-id="element-183">
                    <X className="w-4 h-4 text-[var(--sunset-coral)]" data-id="element-184" />
                  </div>
                  <p className="text-[var(--cream)]/80 leading-relaxed" data-id="element-185">
                    {item}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}